import React, { Component } from "react";
import { Form, Button, Icon, Modal, message, Checkbox } from "antd";
import { Redirect } from "react-router-dom";
import "./LoginPage.css";
import { validateSenha, validateEmail, CPFValido } from "../utils/Validator";
import { maskTelefone, maskCPF } from '../utils/Masker'
import InputForm from "../components/InputForm";
import axios from "axios";
import { saveToken, savePermissoes, isLoggedIn } from '../utils/LoginManager';
import Cookies from 'universal-cookie';
import Colors from "../utils/Colors";
import TermosDeUsoForm from '../components/TermosDeUsoForm';
import LogoFastGestor from '../imagens/logo-fastgestor-pequeno.png';
import SpinnerForm from '../components/SpinnerForm';

const ItemForm = Form.Item;
const cookies = new Cookies();

export const OPCOES_COMBO_MODULO = [
  { key: '1', label: 'PLANO ADVANCED' },
  { key: '2', label: 'PLANO PRO' },
  { key: '3', label: 'PLANO BASIC' },
  { key: '4', label: 'NOTAS FISCAIS' },
]

export default class LoginPage extends Component {
  constructor(props) {
    super(props)

    // Guarda somente o e-mail do último acesso (nunca a senha).
    // O autofill do Chrome nem sempre disponibiliza o valor no DOM durante o mount.
    let usuarioSalvo = '';
    try {
      usuarioSalvo = window.localStorage.getItem('FastGestor-login-ultimo-usuario') || '';
    } catch (error) {
      // Privacidade/armazenamento bloqueados: usar o campo normalmente.
    }

    this.state = {
      usuario: validateEmail(usuarioSalvo) ? usuarioSalvo : '',
      senha: "",
      empresa: "0",
      empresaSelect: [],
      aguarde: false,
      habilitaEmpresa: false,

      novaConta: props && props.location && props.location.search ? props.location.search.substring(11, 12) : '',
      plano: props && props.location && props.location.search ? props.location.search.substring(19, 20) : '',
      nomeEmpresa: '',
      nomeUsuario: '',
      email: '',
      fone: '',
      senha1: '',
      senha2: '',
      modulo: { key: '1', label: '', },

      OKCheck: false
    };

    // Evita consultas duplicadas quando o navegador restaura o e-mail.
    this.timersUsuario = [];
    this.usuarioEmConsulta = '';
    this.sequenciaBuscaEmpresa = 0;
    this.usuarioInteragiu = false;

    // console.log('MainLayout Props:', this.props.location.search.substring(19, 20))
  }


  componentDidMount() {
    // Se já usamos este navegador antes, o state já tem o e-mail salvo.
    // Assim a consulta parte imediatamente, sem esperar foco/blur.
    this.verificarUsuarioAoCarregar();

    // Em um primeiro acesso após a atualização, o navegador ainda pode
    // preencher o campo depois que o React montou os componentes.
    [100, 300, 700, 1300, 2200, 3500, 5500, 8500].forEach(atraso => {
      this.timersUsuario.push(setTimeout(this.verificarUsuarioAoCarregar, atraso));
    });

    this.aoRetornarPagina = () => {
      // BFCache / gerenciador de senhas do navegador.
      this.timersUsuario.push(setTimeout(this.verificarUsuarioAoCarregar, 100));
    };
    window.addEventListener('pageshow', this.aoRetornarPagina);
    window.addEventListener('focus', this.aoRetornarPagina);

    this.onBuscarIPClick();

    this.setState({ modulo: { key: this.state.plano && this.state.plano === 'A' ? '1' : this.state.plano && this.state.plano === 'P' ? '2' : this.state.plano && this.state.plano === 'B' ? '3' : this.state.plano && this.state.plano === 'N' ? '4' : '1', label: '', } });
  }

  componentWillUnmount() {
    this.timersUsuario.forEach(clearTimeout);
    window.removeEventListener('pageshow', this.aoRetornarPagina);
    window.removeEventListener('focus', this.aoRetornarPagina);
    this.sequenciaBuscaEmpresa += 1;
  }

  salvarUsuarioLogin = value => {
    const usuario = String(value || '').trim();
    if (!validateEmail(usuario)) return;
    try {
      window.localStorage.setItem('FastGestor-login-ultimo-usuario', usuario);
    } catch (error) {
      // O login continua funcionando mesmo se o localStorage estiver desativado.
    }
  };

  verificarUsuarioAoCarregar = () => {
    if (this.state.novaConta === 'S') return;

    // Alguns componentes InputForm não propagam o id até o <input> nativo.
    const campo = document.querySelector(
      '.login-fields input[id="usuario"], ' +
      '.login-fields input[name="usuario"], ' +
      '.login-fields input[autocomplete="username"], ' +
      '.login-fields input[type="email"], ' +
      '.login-fields .login-field input:not([type="password"])'
    );
    const usuarioCampo = campo && campo.value ? campo.value.trim() : '';

    // Antes de qualquer interação, aceita o último e-mail salvo como fallback.
    // Após o usuário começar a editar, não sobrescreve o texto com o e-mail antigo.
    const usuario = usuarioCampo || (this.state.usuario || '').trim();
    if (!usuario || !validateEmail(usuario) || this.usuarioEmConsulta === usuario) return;

    this.salvarUsuarioLogin(usuario);
    if (usuario !== this.state.usuario) {
      this.setState({ usuario }, () => this.buscaEmpresa(usuario));
    } else {
      this.buscaEmpresa(usuario);
    }
  };


  onBuscarIPClick = () => {
    // console.log('onBuscarIPClick');
    fetch("http://ip-api.com/json")
      .then(res => res.json())
      .then(
        (result) => {
          // console.log('onBuscarIPClick-OK: ', result);
          const base64 = new Buffer(result.query + result.as + result.lat + result.lon + navigator.userAgent + navigator.deviceMemory + "GB" + navigator.hardwareConcurrency).toString('base64')
          // console.log('base64: ', base64);
          this.setState({ ipbase64: base64 });
        },
        (error) => {
          console.log('onBuscarIPClick-ERRO: ', error);
        }
      )
  }


  onLogin = event => {
    event.preventDefault();

    const { usuario, empresa, senha } = this.state;

    // Mantém o último usuário para abrir a próxima sessão já com as empresas.
    this.salvarUsuarioLogin(usuario);

    if ((!usuario) || (usuario === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Usuário' });
      return;
    }
    if ((!senha) || (senha === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Senha' });
      return;
    }
    if ((!empresa) || (empresa.key === '0') || (empresa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Empresa', });
      return;
    }


    const body = {
      usuario,
      senha,
      empresa: empresa.key ? empresa.key : empresa,
      modulo: 'WEB',
      ipbase64: this.state.ipbase64,
    };

    this.setState({ aguarde: true });

    axios.post("/usuarios/login", body)
      .then(response => {
        this.setState({ aguarde: false });
        saveToken(response.data.token);
        savePermissoes(response.data.grupo);
        message.success('Bem Vindo ao FastGestor');
        this.props.history.push('/'); // vai para a página inicial
      })
      .catch(error => {
        console.log(error.response);
        this.setState({
          aguarde: false
        });
        if (error.response) {
          if (error.response.status === 401) {
            Modal.error({ title: '', content: error.response.data });
          } else if (error.response.status === 402) {
            Modal.error({ title: '', content: 'Usuário não tem acesso ao sistema' });
          } else {
            Modal.error({ title: '', content: 'Erro de conexão com o sistema.' });
          }
        } else {
          Modal.error({ title: '', content: 'Não foi possível se comunicar com o servidor, verifique sua conexão com a internet.' });
        }
      });

  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    if (id === 'usuario' && value !== this.state.usuario) {
      this.usuarioInteragiu = true;
      this.salvarUsuarioLogin(value);
      // Se o e-mail mudar, não manter as empresas da consulta anterior.
      this.sequenciaBuscaEmpresa += 1;
      this.usuarioEmConsulta = '';
      this.setState({
        usuario: value,
        empresa: '0',
        empresaSelect: [],
        habilitaEmpresa: false,
      });
      return;
    }

    this.setState({ [id]: value });
  };

  onChangeCheck = event => {
    const value = event.target.checked;
    this.setState({
      OKCheck: value
    });
  };

  onChangeEmpresa = event => {
    this.setState({
      empresa: event.target.value,
    });
  };

  onBlurCPF = event => {
    const value = event.target.value;
    this.salvarUsuarioLogin(value);
    if (this.consultaUsuarioFalhou && value === this.usuarioEmConsulta) {
      this.usuarioEmConsulta = '';
    }
    this.consultaUsuarioFalhou = false;
    this.setState({
      usuario: value,
    });
    this.buscaEmpresa(value);
  };

  buscaEmpresa = (value) => {
    const usuarioConsulta = String(value || '').trim();

    if (!usuarioConsulta || this.usuarioEmConsulta === usuarioConsulta) return;
    this.usuarioEmConsulta = usuarioConsulta;
    this.consultaUsuarioFalhou = false;
    const consultaId = ++this.sequenciaBuscaEmpresa;

    this.setState({
      empresa: "0",
      empresaSelect: [],
      carregando: false,
      habilitaEmpresa: false,
    });

    axios.get('/usuarios/empresasUsuario', {
      params: {
        ativo: 1,
        usuario: usuarioConsulta,
      }
    }).then(response => {
      if (consultaId !== this.sequenciaBuscaEmpresa) return;
      const { data } = response;
      const empresaSelect = data.map(regList => {
        return {
          key: regList.emp_codigo,
          label: regList.emp_nome
        }
      });
      this.setState({
        empresaSelect,
      })

      if (data) {
        if (data.length > 1) {
          this.setState({
            habilitaEmpresa: true,
          });
        } else if (data.length === 1) {
          const empresa = data[0];
          this.setState({
            habilitaEmpresa: false,
            empresa: empresa.emp_codigo,
          });
          message.success('Usuário Reconhecido.');
        } else {
          message.success('Usuário não Reconhecido');
        }
      } else {
        message.success('Usuário não Reconhecido.');
      }

    }).catch(error => {
      if (consultaId !== this.sequenciaBuscaEmpresa) return;
      this.consultaUsuarioFalhou = true;
      message.error('Não foi possível verificar as empresas do usuário.');
      console.error('Empresa do Usuário não encontrada. Erro.');
      console.error(error.response);
    })
  }






  onGravarNovaContaClick = () => {
    const { nomeEmpresa, nomeUsuario, email, fone, senha1, senha2, modulo } = this.state;

    if ((!nomeEmpresa) || (nomeEmpresa === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome da Empresa' });
      return;
    }
    if ((!nomeUsuario) || (nomeUsuario === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome do Usuário' });
      return;
    }
    if ((!email) || (email === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Email' });
      return;
    }
    if ((email) && (!validateEmail(email))) {
      Modal.warning({ title: 'Aviso!', content: 'Email inválido' });
      return;
    }
    if ((!fone) || (fone === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Telefone' });
      return;
    }

    if ((!senha1) || (senha1 === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a senha' });
      return;
    }
    if (senha1 !== senha2) {
      Modal.warning({ title: 'Aviso!', content: 'As duas Senhas não conferem', });
    }

    if ((!modulo) || (modulo.key === '0') || (modulo === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe Plano para contratação' });
      return;
    }

    const reg = {
      nomeEmpresa,
      nomeUsuario,
      email,
      fone,
      senha1,
      senha2,
      modulo: modulo.key,
      formTermosUsoVisivel: false,
    }

    // console.log('onGravarNovaContaClick: ', reg)
    // return;

    this.setState({ salvando: true })

    axios.put(`/empresas/cadastrosAuto/0`, reg)
      .then(response => {

        if (response.data.empresa === 'S') {
          this.setState({ salvando: false });
          Modal.warning({ title: 'Aviso!', content: 'Email já cadastrado', });
          return;
        }

        message.success('Conta criada com sucesso. Aguarde, entrando no sistema...');

        const body = {
          usuario: email,
          senha: senha1,
          empresa: response.data.empresa,
          modulo: 'WEB',
          ipbase64: '',
        };

        axios.post("/usuarios/login", body)
          .then(response => {
            this.setState({ salvando: false });
            saveToken(response.data.token);
            savePermissoes(response.data.grupo);
            message.success('Bem Vindo ao FastGestor');
            this.props.history.push('/');
          })
          .catch(error => {
            console.log(error.response);
            this.setState({ salvando: false });
          });
      })
      .catch(error => {
        console.log(error.response);
        Modal.error({ title: 'Atenção!', content: error.response.data.mensagem, okText: 'OK', })
        this.setState({
          salvando: false,
        })
      })

  };



  onEsqueciSenhaClick = () => {
    axios.get('/usuarios/enviaEmailRedefinirSenha', {
      params: {
        usuario: this.state.usuario,
        empresa: this.state.empresa && this.state.empresa.key ? this.state.empresa.key : this.state.empresa,
      }
    }).then(response => {

      axios.get('/usuarios/enviaWhatsAppRedefinirSenha', {
        params: {
          usuario: this.state.usuario,
          empresa: this.state.empresa && this.state.empresa.key ? this.state.empresa.key : this.state.empresa,
        }
      }).then(response => {

        message.success('Senha redefinida. Sua nova senha foi enviada para este email e no teu WhatsApp');
        Modal.success({ title: 'Esqueci minha Senha', content: 'Senha redefinida, sua nova senha foi enviada para o teu email e no teu WhatsApp', okText: 'OK', })

      }).catch(error => {

        message.success('Senha redefinida. Sua nova senha foi enviada para este email');
        Modal.success({ title: 'Esqueci minha Senha', content: 'Senha redefinida, sua nova senha foi enviada para o teu email', okText: 'OK', })

      })

    }).catch(error => {

      Modal.error({ title: 'Atenção!', content: 'Informe o email para redefinir a senha. ' + error.response.data.mensagem, okText: 'OK', })
      console.log(error.response);

    })
  }



  onTermoUsoClick = () => {
    this.setState({
      formTermosUsoVisivel: true,
    })
  }

  onCancelarClick = () => {
    this.setState({
      formTermosUsoVisivel: false
    })
  }



  render() {
    if (isLoggedIn()) {
      return <Redirect to="/" />;
    }

    const {
      formTermosUsoVisivel, OKCheck, salvando, usuario, senha, aguarde,
      empresa, empresaSelect, habilitaEmpresa, novaConta, nomeEmpresa,
      nomeUsuario, email, fone, senha1, senha2, modulo,
    } = this.state;

    const isNovaConta = novaConta === 'S';
    const logo = LogoFastGestor;
    const empresaCodigo = empresa && empresa.key ? empresa.key : empresa;
    const empresaValida = Boolean(empresaCodigo && String(empresaCodigo) !== '0');

    // Paleta centralizada no Colors.js da aplicação web.
    // As cores de fallback no CSS são as cores do LoginPage.css original.
    const loginColors = {
      '--login-primary': Colors.primary || '#0c6681',
      '--login-primary-dark': Colors.primaryDark || '#003c54',
      '--login-primary-light': Colors.primaryLight || '#71cace',
    };

    return (
      <div className={`login-page${isNovaConta ? ' login-page--signup' : ''}`} style={loginColors}>
        <aside className="login-brand" aria-label="Apresentação do sistema">
          <div className="login-brand__content">
            <div className="login-brand__logo">
              <img src={logo} alt={'FastGestor'} />
            </div>

            <span className="login-brand__eyebrow">SEU SISTEMA DE GESTÃO</span>
            <h2>Mais organização para o seu dia a dia.</h2>
            <p>Tenha acesso às informações da sua empresa em um ambiente simples e integrado.</p>

            <div className="login-brand__features" aria-hidden="true">
              <div><Icon type="check-circle" /> <span>Informações em um só lugar</span></div>
              <div><Icon type="check-circle" /> <span>Rotina mais organizada</span></div>
              <div><Icon type="check-circle" /> <span>Controle para sua operação</span></div>
            </div>
          </div>
          <div className="login-brand__foot">© {new Date().getFullYear()} Plena Sistemas</div>
        </aside>

        <main className="login-main">
          <div className={`login-form${isNovaConta ? ' login-form--signup' : ''}`}>
            <div className="login-mobile-logo">
              <img src={logo} alt={'FastGestor'} />
            </div>

            {!isNovaConta ? (
              <React.Fragment>
                <header className="login-heading">
                  <span className="login-eyebrow"><span className="login-eyebrow__dot" /> ACESSO AO SISTEMA</span>
                  <h1>Bem-vindo de volta</h1>
                  <p>Entre com seus dados para acessar sua conta.</p>
                </header>

                <Form onSubmit={this.onLogin} className="login-fields">
                  <div className="login-field">
                    <InputForm
                      type="email"
                      id="usuario"
                      autoComplete="username"
                      ref="usuario"
                      title="E-mail"
                      placeholder="seuemail@empresa.com.br"
                      prefix={<Icon type="user" />}
                      size="large"
                      value={usuario}
                      maxLength={100}
                      errorMessage="Email Inválido"
                      validator={validateEmail}
                      onChange={this.onChange}
                      onBlur={this.onBlurCPF}
                    />
                  </div>

                  {empresaSelect.length > 0 && !habilitaEmpresa ? (
                    <div className="login-recognized" role="status">
                      <Icon type="check-circle" />
                      <span className="login-recognized__content">
                        <strong>Empresa identificada</strong>
                        <span>{empresaSelect[0].label}</span>
                      </span>
                    </div>
                  ) : null}

                  <div className="login-field">
                    <InputForm
                      type="password"
                      id="senha"
                      ref="senha"
                      title="Senha"
                      placeholder="Digite sua senha"
                      prefix={<Icon type="lock" />}
                      size="large"
                      maxLength={10}
                      validator={validateSenha}
                      value={senha}
                      onChange={this.onChange}
                      errorMessage="Senha Inválida"
                    />
                  </div>

                  {habilitaEmpresa ? (
                    <div className="login-field">
                      <InputForm
                        type="select"
                        id="empresa"
                        ref="empresa"
                        value={empresa}
                        placeholder="Selecione uma empresa"
                        prefix={<Icon type="home" />}
                        onChange={this.onChangeEmpresa}
                        data={empresaSelect}
                        validator={value => Boolean(value)}
                        errorMessage="Informe a Empresa"
                        showSearch
                      />
                    </div>
                  ) : null}


                  <div className="login-forgot-row">
                    <button type="button" className="login-text-button" onClick={this.onEsqueciSenhaClick}>
                      Esqueceu sua senha?
                    </button>
                  </div>

                  <ItemForm className="login-submit-item">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-botao"
                      size="large"
                      loading={aguarde}
                      disabled={!empresaValida}
                    >
                      Entrar <Icon type="arrow-right" />
                    </Button>
                  </ItemForm>
                </Form>

                <div className="login-account-cta">
                  <span>Ainda não tem uma conta?</span>
                  <a
                    href="https://fastgestor.plenasistemas.inf.br/login?novaconta=S"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cadastre-se gratuitamente <Icon type="arrow-right" />
                  </a>
                </div>

                <nav className="login-footer-links" aria-label="Links de ajuda">
                  <a
                    href="https://api.whatsapp.com/send?1=pt_BR&phone=5544998459635"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon type="message" /> Suporte on-line
                  </a>
                  <button type="button" onClick={this.onTermoUsoClick}>
                    <Icon type="file-text" /> Termos de uso
                  </button>
                </nav>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <header className="login-heading login-heading--signup">
                  <span className="login-eyebrow"><span className="login-eyebrow__dot" /> COMEÇAR AGORA</span>
                  <h1>Crie sua conta</h1>
                  <p>Cadastre sua empresa e experimente o sistema por 15 dias.</p>
                </header>

                <SpinnerForm visivel={salvando} texto={'Criando conta. Aguarde enquanto configuramos seu sistema...'} />

                <div className="login-signup-grid">
                  <div className="login-field login-field--full">
                    <span className="login-signup-label">Empresa</span>
                    <InputForm
                      type="text" id="nomeEmpresa" ref="nomeEmpresa"
                      value={nomeEmpresa} maxLength={60}
                      validator={value => Boolean(value)} onChange={this.onChange}
                    />
                  </div>

                  <div className="login-field login-field--full">
                    <span className="login-signup-label">Nome do usuário</span>
                    <InputForm
                      type="text" id="nomeUsuario" ref="nomeUsuario"
                      value={nomeUsuario} maxLength={60}
                      validator={value => Boolean(value)} onChange={this.onChange}
                    />
                  </div>

                  <div className="login-field login-field--full">
                    <span className="login-signup-label">E-mail profissional</span>
                    <InputForm
                      type="email" id="email" ref="email"
                      value={email} maxLength={100}
                      validator={validateEmail} onChange={this.onChange}
                    />
                  </div>

                  <div className="login-field login-field--full">
                    <span className="login-signup-label">Telefone</span>
                    <InputForm
                      id="fone" ref="fone" value={fone} maxLength={15}
                      carregando masker={maskTelefone} onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </div>

                  <div className="login-field">
                    <span className="login-signup-label">Senha de acesso</span>
                    <InputForm
                      type="password" id="senha1" ref="senha1" value={senha1}
                      minLength={6} maxLength={10} validator={validateSenha}
                      onChange={this.onChange} errorMessage="Senha Inválida"
                    />
                  </div>

                  <div className="login-field">
                    <span className="login-signup-label">Confirmar senha</span>
                    <InputForm
                      type="password" id="senha2" ref="senha2" value={senha2}
                      minLength={6} maxLength={10} validator={validateSenha}
                      onChange={this.onChange} errorMessage="Senha Inválida"
                    />
                  </div>

                  <div className="login-field login-field--full">
                    <span className="login-signup-label">Plano de assinatura</span>
                    <InputForm
                      type="select" id="modulo" ref="modulo" value={modulo}
                      placeholder="Selecione o plano" onChange={this.onChange}
                      data={OPCOES_COMBO_MODULO}
                      validator={value => Boolean(value)} style={{ width: '100%' }}
                    />
                  </div>
                </div>

                <div className="login-signup-checkbox">
                  <Checkbox checked={OKCheck} onChange={this.onChangeCheck}>
                    Desejo experimentar a versão completa por 15 dias
                  </Checkbox>
                </div>

                <Button
                  type="primary" htmlType="button" size="large"
                  loading={salvando} onClick={this.onGravarNovaContaClick}
                  className="login-botao" disabled={!OKCheck}
                >
                  {salvando ? 'Criando conta. Aguarde...' : 'Criar minha conta'}
                </Button>

                <p className="login-signup-terms">
                  Ao se cadastrar, você declara estar de acordo com nossos termos de uso.
                </p>

                <nav className="login-footer-links" aria-label="Links de ajuda">
                  <a
                    href="https://api.whatsapp.com/send?1=pt_BR&phone=5544998459635"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <Icon type="message" /> Suporte on-line
                  </a>
                  <button type="button" onClick={this.onTermoUsoClick}>
                    <Icon type="file-text" /> Termos de uso
                  </button>
                </nav>
                <div className="login-back-link">
                  <a href="/login"><Icon type="arrow-left" /> Voltar ao login</a>
                </div>
              </React.Fragment>
            )}

            <TermosDeUsoForm
              visivel={formTermosUsoVisivel}
              onCancelarClick={this.onCancelarClick}
            />
          </div>
        </main>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js